import { useContext } from 'react'
import { HeaderDropdownContext } from './HeaderDropdown'
import styles from './_headerDropdown.module.scss'
function HeaderDropdownTrigger({ children }) {
  const { isHeaderDropdownOpen, setIsHeaderDropdownOpen } = useContext(
    HeaderDropdownContext
  )
  return (
    <div
      className={styles.trigger}
      onClick={() => setIsHeaderDropdownOpen(!isHeaderDropdownOpen)}
    >
      {children}
    </div>
  )
}

export default HeaderDropdownTrigger
